// import "/assets/libraries/foundation.min.js";

jQuery(document).foundation();
